import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@mui/material'
import { confirmDialogStyles } from '../../styles/classes/GeneralClasses'

export const ConfirmDialog = props => {
  const { classes } = confirmDialogStyles()
  const handleClose = () => {
    props.setOpen(false)
  }

  return (
    <Dialog
      open={props.open}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.switchDialog }}
    >
      <DialogTitle>
        <Typography classes={{ root: classes.dialogTitle }}>{props.title}</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          classes={{ root: classes.dialogContent }}
          id="alert-dialog-slide-description"
        >
          {props.message}
        </DialogContentText>{props.highlightText && (
          <DialogContentText classes={{ root: classes.dialogHighlightText }}>
            {props.highlightText}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Box
          className={`${classes.buttonsContainer} ${props?.customClasses?.buttonsContainer}`}
        >
          {props.cancellabel && (
            <Button
              variant="outlined"
              className={classes.buttonStyle}
              onClick={props.handleCancel ? props.handleCancel : handleClose}
            >
              {props.cancellabel}
            </Button>
          )}
          <Button
            variant="outlined"
            className={classes.okButton}
            onClick={() => props.handleAccept()}
          >
            {props.acceptlabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
